import { auditReports } from '@mi-front/api-clients';
import { useMemo, useState } from 'react';

export function useGipReportResultFilter_v2(schedules: auditReports.GipReportMatchedScheduleDto[]) {
  const [showOffTolerance, setShowOffTolerance] = useState(true);

  const filteredItems = useMemo(() => {
    if (showOffTolerance) {
      return schedules;
    }

    return schedules.filter(
      (i) =>
        i.match.matchedScheduleConfirmationType &&
        i.match.matchedScheduleConfirmationType === 'DEFAULT',
    );
  }, [schedules, showOffTolerance]);

  return {
    showOffTolerance,
    setShowOffTolerance,
    filteredItems,
  };
}
